import React, { useEffect, useState } from "react";
import { FiDownload as DownloadIcon } from "react-icons/fi";
import PaymentServices from "../../services/externalServices/TicketServices/paymentServicesV2";
import ticketicon from "../../../assets/images/Ticket-icon.png";
import purchaseCost from "../../../assets/images/PurchaseCost.png";
import movieicon from "../../../assets/images/movie-icon.png";
import showicon from "../../../assets/images/show-icon.png";
import revenueicon from "../../../assets/images/revenue.png";

const FullReport = () => {
  const [ticketData, setTicketData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState("showDate");
  const [order, setOrder] = useState("desc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [dateOption, setDateOption] = useState("today");
  const [customRange, setCustomRange] = useState({ start: "", end: "" });
  const [theatreFilter, setTheatreFilter] = useState("");
  const [movieFilter, setMovieFilter] = useState("");
  const [showTimeFilter, setShowTimeFilter] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  // const [statusFilter, setStatusFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState('COMPLETED');

  const { role = "", accessList = [] } = JSON.parse(
    localStorage.getItem("admin")
  );
  const isTicketAdmin = role === "ticket-admin";
  const theatreName = accessList?.[0];
  //   const [rowsPerPage, setRowsPerPage] = useState(100);

  useEffect(() => {
    PaymentServices.getFullDetailReports({ theatreName })
      .then((response) => {
        const items = response.data || [];
        console.log("fetched items", items);
        setTicketData(items);
        setFilteredData(items);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching ticket data:", err);
        setLoading(false);
      });
  }, []);

  const handleSort = (field) => {
    const isAsc = orderBy === field && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(field);
  };

  const sortedData = [...filteredData].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  //   const paginatedData = sortedData.slice(
  //     page * rowsPerPage,
  //     page * rowsPerPage + rowsPerPage
  //   );
  const paginatedData = sortedData.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage
  );

  const getDateRange = () => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    // Normalize times to beginning/end of day
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    switch (dateOption) {
      case "yesterday":
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        break;
      case "week":
        start.setDate(start.getDate() - 7);
        break;
      case "month":
        start.setDate(1); // First day of current month
        break;
      case "year":
        start = new Date(now.getFullYear(), 0, 1); // First day of year
        break;
      case "custom":
        return {
          start: customRange.start ? new Date(customRange.start) : null,
          end: customRange.end ? new Date(customRange.end) : null,
        };
      default: // 'today'
        break;
    }
    return { start, end };
  };









  const formatTo12Hour = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    try {
      // Split the date and time
      const [datePart, timePart] = dateTimeString.split(' ');
      const [hours, minutes] = timePart.split(':');

      // Convert to 12-hour format
      const hour12 = parseInt(hours) % 12 || 12;
      const ampm = parseInt(hours) >= 12 ? 'PM' : 'AM';

      return `${datePart} ${hour12}:${minutes} ${ampm}`;
    } catch (error) {
      return dateTimeString; // Return original if conversion fails
    }
  };

  useEffect(() => {
    let filtered = [...ticketData];
    const { start, end } = getDateRange();

    if (start && end) {
      filtered = filtered.filter((t) => {
        try {
          const showDate = new Date(t.showDate);
          console.log("showDate===============", showDate);
          // Normalize the show date to midnight for comparison
          const normalizedShowDate = new Date(showDate);
          normalizedShowDate.setHours(0, 0, 0, 0);

          const normalizedStart = new Date(start);
          normalizedStart.setHours(0, 0, 0, 0);

          const normalizedEnd = new Date(end);
          normalizedEnd.setHours(23, 59, 59, 999);

          return (
            normalizedShowDate >= normalizedStart &&
            normalizedShowDate <= normalizedEnd
          );
        } catch (e) {
          console.error("Invalid date format", t.showDate);
          return false;
        }
      });
    }

    // Rest of your filters...
    if (theatreFilter)
      filtered = filtered.filter((t) => t.theatreName === theatreFilter);
    if (movieFilter)
      filtered = filtered.filter((t) => t.movieName === movieFilter);
    if (showTimeFilter)
      filtered = filtered.filter((t) => t.showTime === showTimeFilter);
    if (paymentMethodFilter)
      filtered = filtered.filter(
        (t) => t.paymentMethod === paymentMethodFilter
      );
    if (statusFilter)
      filtered = filtered.filter((t) => t.transactionStatus === statusFilter);

    setFilteredData(filtered);
    setPage(0);
  }, [
    ticketData,
    dateOption,
    customRange,
    theatreFilter,
    movieFilter,
    showTimeFilter,
    paymentMethodFilter,
    statusFilter,
  ]);

  // const exportCSV = () => {
  //   const headers = [
  //     'Movie', 'Theatre', 'Show Date', 'Show Time', 'Seats',
  //     'Amount', 'Payment Method', 'Payment Mode', 'Transaction ID',
  //     'PaymentStatus',
  //   ];
  //   const rows = ticketData.map(t => [
  //     t.movieName, t.theatreName, t.showDate, t.showTime,
  //     t.bookedSeats.join(', '), t.totalAmount, t.paymentMethod,
  //     t.paymentMode, t.transactionId, t.transactionStatus, t.bookingDate
  //   ]);
  //   const csv = [headers, ...rows].map(r => r.join(',')).join('\n');

  //   const blob = new Blob([csv], { type: 'text/csv' });
  //   const link = document.createElement('a');
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = 'TicketReport.csv';
  //   link.click();
  // };




  //   const exportCSV = () => {
  //     try {
  //       setLoading(true);

  //       // Use filteredData instead of ticketData
  //       const headers = [
  //         "Movie",
  //         "Theatre",
  //         "User PhoneNumber",
  //         "Show Date",
  //         "Show Time",

  //         "Seats",
  //         "Amount",
  //         "Payment Method",
  //         "Payment Mode",
  //         "Transaction ID",
  //         "Payment Status",
  //         "Booking Date",
  //       ];

  //       const rows = filteredData.map((ticket) => [
  //         ticket.movieName || "",
  //         ticket.theatreName || "",
  //         ticket.userPhoneNumber || "",
  //         formatDateToDDMMYYYY(ticket.showDate) || "",
  //         ticket.showTime || "",
  //         ticket.bookedSeats?.join(", ") || "",
  //         ticket.totalAmount || "0",
  //         ticket.paymentMethod || "",
  //         ticket.paymentMode || "",
  //         ticket.transactionId || "",
  //         ticket.transactionStatus || "",
  //         formatDateToDDMMYYYY(ticket.bookingDate) || "",
  //       ]);

  //       // Proper CSV formatting with escaped values
  //       const csvContent = [
  //         headers.join(","),
  //         ...rows.map((row) =>
  //           row
  //             .map((field) => `"${field.toString().replace(/"/g, '""')}"`)
  //             .join(",")
  //         ),
  //       ].join("\n");

  //       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.setAttribute("href", url);
  //       link.setAttribute(
  //         "download",
  //         `tickets_${new Date().toISOString().slice(0, 10)}.csv`
  //       );
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     } catch (error) {
  //       console.error("Export failed:", error);
  //       // Add toast/notification here if available
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  // const exportCSV = () => {
  //   try {
  //     setLoading(true);

  //     // Use filteredData instead of ticketData
  //     const headers = [
  //       "Booking Id",
  //       "Show Date",
  //       "Show Time",
  //       "Movie",
  //       "Theatre",
  //       "User PhoneNumber",
  //       "Seats",
  //       "Amount",
  //       "Payment Method",
  //       "Payment Mode",
  //       "Transaction ID",
  //       "Status",
  //       "Invoice Number",
  //       "Booking Date",
  //       "Purchase Cost",
  //       "Base Amount",
  //       "Total Tax",
  //       "Platform Fee",
  //       "Gateway Charges",
  //       "Discount",
  //       "ARN"
  //     ];

  //     const rows = filteredData.map((ticket) => [
  //       ticket.bookingId || "",
  //       formatDateToDDMMYYYY(ticket.showDate) || "",
  //       ticket.showTime || "",
  //       ticket.movieName || "",
  //       ticket.theatreName || "",
  //       ticket.userPhoneNumber || "",
  //       ticket.bookedSeats?.join(", ") || "",
  //       ticket.totalAmount || "0",
  //       ticket.paymentMethod || "",
  //       ticket.paymentMode || "",
  //       ticket.transactionId || "",
  //       ticket.transactionStatus || "",
  //       ticket.invoiceNumber || "",
  //       formatDateToDDMMYYYY(ticket.bookingDate) || "",
  //       ticket.purchaseCost || "0",
  //       ticket.priceSplit?.baseAmount?.value || "0",
  //       ticket.priceSplit?.totalTax?.value || "0",
  //       ticket.priceSplit?.platformFee?.total?.value || "0",
  //       ticket.priceSplit?.gatewayCharges?.total?.value || "0",
  //       ticket.priceSplit?.discount?.value || "0",
  //       ticket.paymentDetails?.data?.paymentInstrument?.arn || ""
  //     ]);

  //     // Proper CSV formatting with escaped values
  //     const csvContent = [
  //       headers.join(","),
  //       ...rows.map((row) =>
  //         row
  //           .map((field) => {
  //             // Convert to string and escape quotes
  //             const str = field?.toString() || "";
  //             return `"${str.replace(/"/g, '""')}"`;
  //           })
  //           .join(",")
  //       ),
  //     ].join("\n");

  //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.setAttribute("href", url);
  //     link.setAttribute(
  //       "download",
  //       `tickets_${new Date().toISOString().slice(0, 10)}.csv`
  //     );
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Export failed:", error);
  //     // Add toast/notification here if available
  //     alert("Export failed. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };







  const exportCSV = () => {
    try {
      setLoading(true);

      const headers = [
        "Booking Date", "Booking Time", "Show Date", "Show Time", "Booking Id",
        "Movie", "Theatre", "User PhoneNumber", "Seats", "Amount", "Payment Method",
        "Payment Mode", "Transaction ID", "Status", "Invoice Number", "Purchase Cost",
        "Base Amount", "Total Tax", "Platform Fee", "Gateway Charges", "Discount",
        "Merchant Transaction ID", "UTR", "UPI Transaction ID", "ARN",
        "Account Holder Name", "Payment Type", "Account Type", "Card Network"
      ];

      const rows = filteredData.map((ticket) => {
        const instrument = ticket.paymentDetails?.paymentInstrument;

        return [
          ticket.bookingDate?.split(' ')[0] ? formatDateToDDMMYYYY(ticket.bookingDate.split(' ')[0]) : "",
          ticket.bookingDate?.split(' ')[1] || "",
          ticket.showDate ? formatDateToDDMMYYYY(ticket.showDate) : "",
          ticket.showTime || "",
          ticket.bookingId || "",
          ticket.movieName || "",
          ticket.theatreName || "",
          ticket.userPhoneNumber || "",
          Array.isArray(ticket.bookedSeats) ? ticket.bookedSeats.join("; ") : "",
          ticket.totalAmount || "0",
          ticket.paymentMethod || "",
          ticket.paymentMode || "",
          ticket.transactionId || "",
          ticket.transactionStatus || "",
          ticket.invoiceNumber || "",
          ticket.purchaseCost || "0",
          ticket.priceSplit?.baseAmount?.value || "0",
          ticket.priceSplit?.totalTax?.value || "0",
          ticket.priceSplit?.platformFee?.total?.value || "0",
          ticket.priceSplit?.gatewayCharges?.total?.value || "0",
          ticket.priceSplit?.discount?.value || "0",
          ticket.paymentDetails?.merchantTransactionId || "",
          instrument?.utr || "",
          instrument?.upiTransactionId || "",
          instrument?.arn || "",
          instrument?.accountHolderName || "",
          instrument?.type || "",
          instrument?.accountType || "",
          instrument?.cardNetwork || ""
        ];
      });

      // Create CSV with BOM for proper Unicode support
      const BOM = '\uFEFF';
      const csvContent = BOM + [
        headers.join(","),
        ...rows.map((row) =>
          row.map((field) => {
            const str = (field?.toString() || "").replace(/"/g, '""');
            return `"${str}"`;
          }).join(",")
        ),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      const filename = `booking_report_${timestamp}.csv`;

      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("❌ CSV Export failed:", error);
      alert("Export failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  const getOptions = (field, base = filteredData) => {
    return [...new Set(base.map((t) => t[field]))].filter(Boolean).sort();
  };

  const clearFilters = () => {
    setDateOption("today");
    setCustomRange({ start: "", end: "" });
    setTheatreFilter("");
    setMovieFilter("");
    setShowTimeFilter("");
    setPaymentMethodFilter("");
    // setStatusFilter("");
    setStatusFilter('COMPLETED'); // Change this from '' to 'COMPLETED'
  };

  const formatDateToDDMMYYYY = (dateInput) => {
    if (!dateInput) return "";
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date.getTime())) return "Invalid date";
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const calculateMetrics = (data) => {
    console.log("data purchase cost", data[0]?.purchaseCost);
    if (data.length === 0) {
      return {
        totalTickets: 0,
        totalRevenue: 0,
        totalRevenue: 0,
        mostPopularShowTime: "N/A",
        mostPopularMovie: "N/A",
        filteredMovie: null,
        showTimeFilter: null, // Add this
      };
    }

    const totalTickets = data.reduce(
      (sum, ticket) => sum + ticket.bookedSeats.length,
      0
    );
    const totalRevenue = data.reduce(
      (sum, ticket) => sum + (ticket.totalAmount || 0),
      0
    );

    const uniqueMovieTheatrePairs = new Map();

    data.forEach((ticket) => {
      const key = `${ticket.movieName}-${ticket.theatreName}`;
      if (!uniqueMovieTheatrePairs.has(key) && ticket.purchaseCost) {
        uniqueMovieTheatrePairs.set(key, ticket.purchaseCost);
      }
    });

    const avgPaymentCost = [...uniqueMovieTheatrePairs.values()].reduce(
      (sum, cost) => sum + cost,
      0
    );

    // Check if we're filtering by a specific movie
    const uniqueMovies = [...new Set(data.map((item) => item.movieName))];
    const filteredMovie = uniqueMovies.length === 1 ? uniqueMovies[0] : null;

    const showTimeCounts = data.reduce((acc, ticket) => {
      acc[ticket.showTime] =
        (acc[ticket.showTime] || 0) + ticket.bookedSeats.length;
      return acc;
    }, {});

    const mostPopularShowTime =
      Object.entries(showTimeCounts).sort((a, b) => b[1] - a[1])[0]?.[0] ||
      "N/A";

    // Only calculate popular movie if not filtered by a specific movie
    let mostPopularMovie = "N/A";
    if (!filteredMovie) {
      const movieCounts = data.reduce((acc, ticket) => {
        acc[ticket.movieName] =
          (acc[ticket.movieName] || 0) + ticket.bookedSeats.length;
        return acc;
      }, {});

      mostPopularMovie =
        Object.entries(movieCounts).sort((a, b) => b[1] - a[1])[0]?.[0] ||
        "N/A";
    }

    return {
      totalTickets,
      totalRevenue,
      mostPopularShowTime,
      mostPopularMovie,
      filteredMovie,
      avgPaymentCost,
      showTimeFilter, // Add this to the returned object
    };
  };

  const findDuplicateSeats = () => {
    // First normalize all seat data for accurate comparison
    const normalizedData = filteredData.map(booking => ({
      ...booking,
      normalizedSeats: booking.bookedSeats.map(seat =>
        seat.trim().toLowerCase().replace(/\s+/g, ' ')
      ),
      originalSeats: booking.bookedSeats // Keep original for display
    }));

    // Group bookings by theater, date, and show time
    const grouped = normalizedData.reduce((acc, booking) => {
      const key = `${booking.theatreName}-${booking.showDate}-${booking.showTime}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(booking);
      return acc;
    }, {});

    // Find duplicates and track which seats are duplicated
    const duplicates = [];
    const duplicateDetails = [];

    Object.entries(grouped).forEach(([key, group]) => {
      if (group.length > 1) {
        // Collect all seats for this show
        const allSeatEntries = group.flatMap(booking =>
          booking.normalizedSeats.map((seat, index) => ({
            seat,
            original: booking.originalSeats[index],
            bookingId: booking.bookingId,
            userPhone: booking.userPhoneNumber,
            theatre: booking.theatreName,
            showTime: booking.showTime,
            showDate: booking.showDate
          }))
        );

        // Find duplicates within these seats
        const seatCounts = allSeatEntries.reduce((counts, { seat }) => {
          counts[seat] = (counts[seat] || 0) + 1;
          return counts;
        }, {});

        const duplicatedSeats = Object.entries(seatCounts)
          .filter(([_, count]) => count > 1)
          .map(([seat]) => seat);

        if (duplicatedSeats.length > 0) {
          // Find all bookings that have these duplicated seats
          const duplicateBookings = group.filter(booking =>
            booking.normalizedSeats.some(seat =>
              duplicatedSeats.includes(seat)
            )
          );

          duplicates.push(...duplicateBookings);

          // Store detailed info about which seats are duplicated
          duplicatedSeats.forEach(seat => {
            const conflictingBookings = allSeatEntries
              .filter(entry => entry.seat === seat)
              .map(entry => ({
                bookingId: entry.bookingId,
                phone: entry.userPhone,
                seat: entry.original
              }));

            duplicateDetails.push({
              theatre: group[0].theatreName,
              date: group[0].showDate,
              time: group[0].showTime,
              seat: allSeatEntries.find(e => e.seat === seat).original,
              conflicts: conflictingBookings
            });
          });
        }
      }
    });

    if (duplicates.length > 0) {
      // Filter the table to show only duplicate bookings
      setFilteredData(duplicates);

      // Create a detailed message about the conflicts
      // const message = duplicateDetails.map(detail => 
      //   `Theatre: ${detail.theatre}\n` +
      //   `Show: ${detail.date} at ${detail.time}\n` +
      //   `Seat "${detail.seat}" is booked by:\n` +
      //   detail.conflicts.map(c => 
      //     `- Booking ${c.bookingId} (Phone: ${c.phone})`
      //   ).join('\n')
      // ).join('\n\n');

      alert(`Found ${duplicates.length} bookings with duplicate seats`);

      // You could also set this in state and show in a modal instead of alert
      // setDuplicateDetails(duplicateDetails);
    } else {
      alert('No duplicate seat bookings found');
    }
  };



  const SummaryCards = ({ data }) => {
    const metrics = calculateMetrics(data);

    console.log('metrics', metrics)

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 py-2 px-1">
        {/* Total Payment Cost Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-blue-500">
          <div className="p-3 bg-blue-50 rounded-full">
            <img src={purchaseCost} alt='payment' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Payment Cost</h3>
            <p className="text-2xl font-bold my-1 text-gray-800 truncate">
              ₹{typeof metrics.avgPaymentCost === 'number'
                ? metrics.avgPaymentCost.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00'}
            </p>
            <p className="text-gray-400 text-xs">Purchase cost of movie</p>
          </div>
        </div>

        {/* Total Tickets Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-green-500">
          <div className="p-3 bg-yellow-50 rounded-full">
            <img src={ticketicon} alt='tickets' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Tickets</h3>
            <p className="text-2xl font-bold my-1 text-gray-800">{metrics.totalTickets}</p>
            <p className="text-gray-400 text-xs">Booked seats</p>
          </div>
        </div>

        {/* Total Revenue Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-purple-500">
          <div className="p-3 bg-blue-50 rounded-full">
            <img src={revenueicon} alt='revenue' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Revenue</h3>
            <p className="text-2xl font-bold my-1 text-gray-800">
              ₹{metrics.totalRevenue.toLocaleString('en-IN')}
            </p>
            <p className="text-gray-400 text-xs">Total collected</p>
          </div>
        </div>

        {/* Popular Show Time Card */}
        {/* <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
          <div className="p-3 bg-purple-50 rounded-full">
            <img src={showicon} alt='show' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
            <p className="text-2xl font-bold my-1 text-gray-800 truncate">
              {metrics.mostPopularShowTime || 'N/A'}
            </p>
            <p className="text-gray-400 text-xs">Most booked time</p>
          </div>
        </div> */}






        {metrics.showTimeFilter ? (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
            <div className="p-3 bg-purple-50 rounded-full">
              <img src={showicon} alt='show' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Show</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.showTimeFilter}
              </p>
              <p className="text-gray-400 text-xs">Current filter</p>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.mostPopularShowTime}
              </p>
              <p className="text-gray-400 text-xs">Most booked time</p>
            </div>
          </div>
        )}

        {/* Movie Card (Conditional) */}
        {metrics.filteredMovie ? (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Movie</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.filteredMovie}
              </p>
              <p className="text-gray-400 text-xs">Current filter</p>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Movie</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.mostPopularMovie || 'N/A'}
              </p>
              <p className="text-gray-400 text-xs">Most booked film</p>
            </div>
          </div>
        )}
      </div>
    );
  };




// In your component
const downloadInvoice = async (phoneNumber) => {
  try {
    console.log('Making download request...');
    const blob = await PaymentServices.getDownloadInvoice(phoneNumber);
    
    console.log('Blob received:', blob);
    console.log('Blob type:', blob.type);
    console.log('Blob size:', blob.size);

    // Trigger download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `invoice-${phoneNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    console.log('Download completed successfully');
  } catch (err) {
    console.error('Download error:', err);
    alert('Failed to download invoice');
  }
};
  
  
  






  return (
    <div className="md:max-w-5xl mx-auto mb-4">
      <div className="mb-6">
        {/* <h2 className="text-3xl font-semibold">Ticket Summary</h2> */}
        {/* Date Range Presets */}

        <div className="bg-white rounded-lg shadow-md p-4 mb-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Filter Tickets
          </h3>

          {/* Top Row Filters - Date Range and Payment Method */}
          <div className="flex flex-col sm:flex-row gap-4 mb-4">
            {/* Date Filter Section */}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Theatre
              </label>
              <select
                value={theatreFilter}
                onChange={(e) => setTheatreFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Theatres</option>
                {getOptions("theatreName", ticketData).map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date Range
              </label>
              <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                <div className="relative w-full sm:w-40">
                  <select
                    value={dateOption}
                    onChange={(e) => setDateOption(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-gray-200 appearance-none"
                  >
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="week">Last 7 Days</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                    <option value="custom">Custom</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>

                {/* Custom Date Range - Appears inline when 'custom' is selected */}
                {dateOption === "custom" && (
                  <div className="flex items-center gap-2 w-full sm:w-auto">
                    <input
                      type="date"
                      value={customRange.start}
                      onChange={(e) =>
                        setCustomRange((prev) => ({
                          ...prev,
                          start: e.target.value,
                        }))
                      }
                      className="w-full sm:w-36 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                    <span className="text-gray-500">to</span>
                    <input
                      type="date"
                      value={customRange.end}
                      onChange={(e) =>
                        setCustomRange((prev) => ({
                          ...prev,
                          end: e.target.value,
                        }))
                      }
                      className="w-full sm:w-36 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Bottom Row Filters - Theatre, Movie, Show Time, Status */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            {/* Theatre Dropdown */}

            {/* Movie Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Movie
              </label>
              <select
                value={movieFilter}
                onChange={(e) => setMovieFilter(e.target.value)}
                disabled={!theatreFilter}
                className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${!theatreFilter ? "bg-gray-100 text-gray-400" : ""
                  }`}
              >
                <option value="">All Movies</option>
                {getOptions(
                  "movieName",
                  ticketData.filter((t) => t.theatreName === theatreFilter)
                ).map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>

            {/* Show Time Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Show Time
              </label>
              <select
                value={showTimeFilter}
                onChange={(e) => setShowTimeFilter(e.target.value)}
                disabled={!movieFilter}
                className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${!movieFilter ? "bg-gray-100 text-gray-400" : ""
                  }`}
              >
                <option value="">All Show Times</option>
                {getOptions(
                  "showTime",
                  ticketData.filter(
                    (t) =>
                      t.theatreName === theatreFilter &&
                      t.movieName === movieFilter
                  )
                ).map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>

            {/* Status Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Statuses</option>
                {getOptions("transactionStatus", ticketData).map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>

            {/* Payment Method - Moved up beside Date Range */}

            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Payment Method
              </label>
              <select
                value={paymentMethodFilter}
                onChange={(e) => setPaymentMethodFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Methods</option>
                {getOptions("paymentMethod", ticketData).map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Clear Filters Button */}
          {/* <button
            onClick={clearFilters}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Clear All Filters
          </button>


          <button
            onClick={exportCSV}
            className="flex items-center bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors"
          >
            <DownloadIcon className="h-5 w-5 mr-2" />
            Generate Report
          </button> */}

          <div className="flex flex-wrap gap-2 mt-4">
            {/* Clear Filters Button */}
            <button
              onClick={clearFilters}
              className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
              Clear All Filters
            </button>

            {/* Export CSV Button */}
            <button
              onClick={exportCSV}
              disabled={loading || filteredData.length === 0}
              className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading || filteredData.length === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-black hover:bg-gray-800 text-white"
                }`}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Exporting...
                </>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Generate Report
                </>
              )}
            </button>


            <button
              onClick={findDuplicateSeats}
              disabled={loading || filteredData.length === 0}
              className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading || filteredData.length === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-yellow-500 hover:bg-yellow-600 text-white"
                }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
              Find Duplicate Seats
            </button>



          </div>
        </div>
      </div>
      {!loading && filteredData.length > 0 && (
        <SummaryCards data={filteredData} />
      )}

      {/* Results Section */}
      {loading ? (
        <div className="flex justify-center items-center h-24">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
        </div>
      ) : filteredData.length === 0 ? (
        <div className="text-center py-12">
          <div className="mx-auto h-24 w-24 text-gray-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h3 className="mt-2 text-lg font-medium text-gray-700">
            No tickets found
          </h3>
          <p className="mt-1 text-gray-500">
            Try adjusting your search or filter criteria
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-black">
                <tr>
                  {[
                    { label: "Booking Date", field: "bookingDate" },
                    { label: "Booking Time", field: "bookingTime" },
                    { label: "Show Date", field: "showDate" },
                    { label: "Show Time", field: "showTime" },
                    { label: "Booking Id", field: "bookingId" },
                    { label: "Movie", field: "movieName" },
                    { label: "Theatre", field: "theatreName" },
                    { label: "User PhoneNumber", field: "userPhoneNumber" },
                    { label: "Seats", field: "bookedSeats" },
                    { label: "Amount", field: "totalAmount" },
                    { label: "Payment Method", field: "paymentMethod" },
                    { label: "Payment Mode", field: "paymentMode" },
                    { label: "Transaction ID", field: "transactionId" },
                    { label: "Status", field: "transactionStatus" },
                    { label: "Invoice Number", field: "invoiceNumber" },
                    { label: "Purchase Cost", field: "purchaseCost" },
                    { label: "Base Amount", field: "priceSplit.baseAmount.value" },
                    { label: "Total Tax", field: "priceSplit.totalTax.value" },
                    { label: "Platform Fee", field: "priceSplit.platformFee.total.value" },
                    { label: "Gateway Charges", field: "priceSplit.gatewayCharges.total.value" },
                    { label: "Discount", field: "priceSplit.discount.value" },
                    { label: "Merchant Txn ID", field: "paymentDetails.merchantTransactionId" },
                    { label: "Payment Reference", field: "paymentReference" },
                    { label: "Account Holder", field: "paymentDetails.paymentInstrument.accountHolderName" },
                    { label: "Payment Type", field: "paymentDetails.paymentInstrument.type" },
                    { label: "Account Type", field: "paymentDetails.paymentInstrument.accountType" },
                    { label: "UserId", field: "userId" },
                    { label: "InvoiceDownload" }
                  ].map((col) => (
                    <th
                      key={col.field}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider cursor-pointer hover:bg-gray-700 transition-colors duration-150"
                      onClick={() => handleSort(col.field)}
                    >
                      <div className="flex items-center">
                        {col.label}
                        {orderBy === col.field && (
                          <span className="ml-2">
                            {order === "asc" ? (
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M5 15l7-7 7 7"
                                />
                              </svg>
                            ) : (
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            )}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedData.map((t, idx) => {
                  // ✅ UPDATED: Improved helper function to handle manual entries
                  const getPaymentReference = (paymentDetails) => {
                    // Check for manual entry first
                    if (!paymentDetails || Object.keys(paymentDetails).length === 0) {
                      return "MANUAL ENTRY";
                    }

                    const instrument = paymentDetails?.paymentInstrument;

                    // If no instrument but we have merchantTransactionId, use that
                    if (!instrument && paymentDetails.merchantTransactionId) {
                      return paymentDetails.merchantTransactionId;
                    }

                    // If no instrument, check if it's manual
                    if (!instrument) return "MANUAL ENTRY";

                    // For UPI payments
                    if (instrument.type === "UPI") {
                      return instrument.utr || instrument.upiTransactionId || "N/A";
                    }

                    // For Card payments
                    if (instrument.type === "CARD") {
                      return instrument.arn || instrument.cardToken || instrument.last4 || "N/A";
                    }

                    // For other payment types, check for any available reference
                    return instrument.referenceId ||
                      instrument.transactionId ||
                      paymentDetails.transactionId ||
                      paymentDetails.merchantTransactionId ||
                      "MANUAL ENTRY";
                  };

                  return (
                    <tr key={idx} className="hover:bg-gray-50 transition-colors duration-150">
                      {/* Booking Date */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        <div className="group relative">
                          <div className="cursor-pointer" title="Booking Date">
                            {formatDateToDDMMYYYY(formatTo12Hour(t.bookingDate)?.split(' ')[0])}
                          </div>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                            <span className="font-medium">Booking Date:</span><br />
                            {formatDateToDDMMYYYY(formatTo12Hour(t.bookingDate)?.split(' ')[0])}
                          </div>
                        </div>
                      </td>

                      {/* Booking Time */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <span className="px-2 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium cursor-pointer">
                            {formatTo12Hour(t.bookingDate)?.split(' ').slice(1).join(' ') || 'N/A'}
                          </span>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                            <span className="font-medium">Booking Time:</span><br />
                            {formatTo12Hour(t.bookingDate)?.split(' ').slice(1).join(' ') || 'N/A'}
                          </div>
                        </div>
                      </td>

                      {/* Show Date */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="cursor-pointer" title="Show Date">
                            {formatDateToDDMMYYYY(t.showDate)}
                          </div>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                            <span className="font-medium">Show Date:</span><br />
                            {formatDateToDDMMYYYY(t.showDate)}
                          </div>
                        </div>
                      </td>

                      {/* Show Time */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium cursor-pointer">
                            {t.showTime}
                          </span>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                            <span className="font-medium">Show Time:</span><br />
                            {t.showTime}
                          </div>
                        </div>
                      </td>

                      {/* ✅ UPDATED: Booking ID with tooltip */}
                      <td className="px-6 py-4 text-sm font-semibold text-gray-900">
                        <div className="group relative">
                          <div className="break-all leading-tight cursor-pointer" title="Full booking ID">
                            {t.bookingId}
                          </div>
                          {t.bookingId && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Full Booking ID:</span><br />
                              {t.bookingId}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* ✅ UPDATED: Movie with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
                        <div className="group relative">
                          <div className="max-w-40 truncate cursor-pointer" title={t.movieName}>
                            {t.movieName}
                          </div>
                          {t.movieName && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Movie:</span><br />
                              {t.movieName}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* ✅ UPDATED: Theatre with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="max-w-32 truncate cursor-pointer" title={t.theatreName}>
                            {t.theatreName}
                          </div>
                          {t.theatreName && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Theatre:</span><br />
                              {t.theatreName}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* ✅ UPDATED: User Phone Number with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="cursor-pointer" title="Phone Number">
                            {t.userPhoneNumber}
                          </div>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                            <span className="font-medium">Phone:</span><br />
                            {t.userPhoneNumber}
                          </div>
                        </div>
                      </td>

                      {/* ✅ UPDATED: Seats with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="flex flex-wrap gap-1 max-w-xs cursor-pointer">
                            {t.bookedSeats?.map((seat, i) => (
                              <span
                                key={i}
                                className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs"
                              >
                                {seat}
                              </span>
                            ))}
                          </div>
                          {t.bookedSeats && t.bookedSeats.length > 0 && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">All Seats:</span><br />
                              {t.bookedSeats.join(', ')}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Amount */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-green-600">
                        ₹{t.totalAmount}
                      </td>

                      {/* Payment Method */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs font-medium">
                          {t.paymentMethod}
                        </span>
                      </td>

                      {/* Payment Mode */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {t.paymentMode || 'N/A'}
                      </td>

                      {/* ✅ UPDATED: Transaction ID with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
                        <div className="group relative">
                          <div className="max-w-32 truncate cursor-pointer" title={t.transactionId || "N/A"}>
                            {t.transactionId || 'N/A'}
                          </div>
                          {t.transactionId && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Transaction ID:</span><br />
                              {t.transactionId}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Status */}
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span
                          className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${t.transactionStatus === "PENDING"
                              ? "bg-yellow-100 text-yellow-800"
                              : t.transactionStatus === "COMPLETED"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                        >
                          {t.transactionStatus}
                        </span>
                      </td>

                      {/* ✅ UPDATED: Invoice Number with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
                        <div className="group relative">
                          <div className="cursor-pointer" title="Invoice Number">
                            {t.invoiceNumber || "N/A"}
                          </div>
                          {t.invoiceNumber && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                              <span className="font-medium">Invoice #:</span><br />
                              {t.invoiceNumber}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Purchase Cost */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.purchaseCost || "0"}
                      </td>

                      {/* Base Amount */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.priceSplit?.baseAmount?.value || "N/A"}
                      </td>

                      {/* Total Tax */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.priceSplit?.totalTax?.value || "N/A"}
                      </td>

                      {/* Platform Fee */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.priceSplit?.platformFee?.total?.value || "N/A"}
                      </td>

                      {/* Gateway Charges */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.priceSplit?.gatewayCharges?.total?.value || "N/A"}
                      </td>

                      {/* Discount */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        ₹{t.priceSplit?.discount?.value || "0"}
                      </td>

                      {/* ✅ UPDATED: Merchant Transaction ID - Show full ID with tooltip */}
                      <td className="px-6 py-4 text-sm text-gray-600 font-mono">
                        <div className="group relative">
                          <div className="break-all leading-tight cursor-pointer" title="Full transaction ID">
                            {t.paymentDetails?.merchantTransactionId || "N/A"}
                          </div>
                          {t.paymentDetails?.merchantTransactionId && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Merchant Transaction ID:</span><br />
                              {t.paymentDetails.merchantTransactionId}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* ✅ UPDATED: Dynamic Payment Reference with better manual entry handling and tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="flex flex-col cursor-pointer">
                            <span className="font-mono text-xs">
                              <div className="max-w-32 truncate" title={getPaymentReference(t.paymentDetails)}>
                                {getPaymentReference(t.paymentDetails)}
                              </div>
                            </span>
                            <span className="text-xs text-gray-400">
                              {(() => {
                                const reference = getPaymentReference(t.paymentDetails);

                                if (reference === "MANUAL ENTRY" || t.userId === "MANUAL" || !t.paymentDetails || Object.keys(t.paymentDetails).length === 0) {
                                  return "MANUAL";
                                }

                                const instrument = t.paymentDetails?.paymentInstrument;

                                if (instrument?.type === "UPI") {
                                  if (instrument.utr) return "UTR";
                                  if (instrument.upiTransactionId) return "UPI ID";
                                }

                                if (instrument?.type === "CARD") {
                                  if (instrument.arn) return "ARN";
                                  if (instrument.cardToken) return "TOKEN";
                                  if (instrument.last4) return "CARD";
                                }

                                if (reference === t.paymentDetails?.merchantTransactionId) {
                                  return "MERCHANT";
                                }

                                return "REF";
                              })()}
                            </span>
                          </div>
                          <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                            <span className="font-medium">Payment Reference:</span><br />
                            {getPaymentReference(t.paymentDetails)}
                          </div>
                        </div>
                      </td>

                      {/* ✅ UPDATED: Account Holder Name with tooltip */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="group relative">
                          <div className="max-w-32 truncate cursor-pointer" title={t.paymentDetails?.paymentInstrument?.accountHolderName || "N/A"}>
                            {t.paymentDetails?.paymentInstrument?.accountHolderName || "N/A"}
                          </div>
                          {t.paymentDetails?.paymentInstrument?.accountHolderName && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                              <span className="font-medium">Account Holder:</span><br />
                              {t.paymentDetails.paymentInstrument.accountHolderName}
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Payment Type */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.paymentDetails?.paymentInstrument?.type === "UPI"
                            ? "bg-green-50 text-green-700"
                            : t.paymentDetails?.paymentInstrument?.type === "CARD"
                              ? "bg-blue-50 text-blue-700"
                              : "bg-gray-50 text-gray-700"
                          }`}>
                          {t.paymentDetails?.paymentInstrument?.type || "N/A"}
                        </span>
                      </td>

                      {/* Account Type */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {t.paymentDetails?.paymentInstrument?.accountType || "N/A"}
                      </td>

                      {/* User ID */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.userId === "MANUAL"
                            ? "bg-orange-50 text-orange-700"
                            : "bg-gray-50 text-gray-700"
                          }`}>
                          {t.userId || "N/A"}
                        </span>
                      </td>


                      {/* Download Invoice */}

                      {/* Download Invoice */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => downloadInvoice(t?.userPhoneNumber)}
                          className="px-3 py-1 bg-blue-600 text-white rounded text-xs"
                        >
                          Download Invoice
                        </button>
                      </td>

                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>

          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
            <div className="flex items-center">
              <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
              <select
                className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none bg-white"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(0);
                }}
              >
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
              </select>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={() => setPage(Math.max(0, page - 1))}
                disabled={page === 0}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              <button
                onClick={() =>
                  setPage(
                    Math.min(
                      Math.ceil(filteredData.length / rowsPerPage) - 1,
                      page + 1
                    )
                  )
                }
                disabled={
                  page >= Math.ceil(filteredData.length / rowsPerPage) - 1
                }
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>

      )}

      {/* Keep existing SummaryCards and table rendering logic here */}
    </div>
  );
};

export default FullReport;

